export default "__VITE_ASSET__LDzyTe0F__"